import { useState, useEffect, useRef } from "react";
import { useGlobalContext } from "../../../../../Context/Context";
import Button from "../../../../Custom/Button/Button";
import axios from "axios";
import CustomAutocomplete from "../../../Documents/sredstva-oprema/sredstva-prva-pomoc/CustomAutocomplete";
import CustomInput from "../CustomInput";
import CustomSelectWithLabel from "../CustomSelectWithLabel";
import deleteImg from "../../../../picture/cancel.png";

const kategorijeAll = ["MASINA", "UREDJAJ", "ALAT"];

const sredstvoMock = {
  kategorija: "",
  vrsta: { id: -1, name: "" },
  tip: "",
  oznaka: "",
  poslovnaJedinica: { id: -1, name: "" },
  lokacija: "",
  strucniNalazBroj: "",
  strucniNalazIstice: "",
  strucniNalazFile: null,
  strucni_nalaz_path: "",
  broj_vazecih_dokumenata: 0,
  broj_kriticnih_dokumenata: 0,
  foto: null,
  foto_path: "",
  napomena: "",
  uputstvo: ""
};

const styles = {
  input: { width: "100%", fontSize: "16px", height: "40px", padding: "10px" }
};

const mapToBackendData = (formSredstvo) => ({
  ...formSredstvo,
  vrsta_id: formSredstvo.vrsta.id,
  vrsta_naziv: formSredstvo.vrsta.name,
  strucni_nalaz_broj: formSredstvo.strucniNalazBroj,
  strucni_nalaz_istice: formSredstvo.strucniNalazIstice,
  poslovna_jedinica_id: formSredstvo.poslovnaJedinica.id,
  poslovna_jedinica_name: formSredstvo.poslovnaJedinica.name
});

function DodavanjeSredstva({ setCurrentState, editSredstvoData }) {
  const [sredstvo, setSredstvo] = useState(sredstvoMock);
  const [vrsteAll, setVrsteAll] = useState([]);
  const [poslovneJediniceAll, setPoslovneJediniceAll] = useState([]);
  const [lokacijeAll, setLokacijeAll] = useState([]);

  const fileInputRef = useRef();
  const fotoInputRef = useRef();

  const {
    dictionary,
    baseUrl,
    apiKey,
    loggedUser,
    setMasineUredjaji,
    selectedMainEntity
  } = useGlobalContext();

  useEffect(() => {
    if (!loggedUser || !apiKey || !selectedMainEntity?.company_id) return;
    const authPayload = {
      user_id: loggedUser.id,
      api_key: apiKey,
      company_id: selectedMainEntity.company_id
    };
    const fetchData = async () => {
      try {
        const resUnits = await axios.post(
          `${baseUrl}/unit/read.php`,
          authPayload
        );
        if (resUnits.data.status === 200)
          setPoslovneJediniceAll(resUnits.data.data);
        const resLokacije = await axios.post(
          `${baseUrl}/machines/getAllLocations.php`,
          authPayload
        );
        if (resLokacije.data.status === 200)
          setLokacijeAll(resLokacije.data.data);
      } catch (error) {
        console.error("Greška pri učitavanju šifarnika", error);
      }
    };
    fetchData();
  }, [loggedUser, apiKey, baseUrl, selectedMainEntity]);

  const fetchVrste = async (kategorija) => {
    try {
      const resVrste = await axios.post(
        `${baseUrl}/vrste_masina_uredjaja/getVrsteSredstava.php`,
        {
          user_id: loggedUser.id,
          api_key: apiKey,
          company_id: selectedMainEntity.company_id,
          kategorija
        }
      );
      if (resVrste.data.status === 200) {
        setVrsteAll(
          resVrste.data.data.map((item) => ({
            id: item.vrsta_id,
            name: item.naziv
          }))
        );
      }
    } catch (error) {
      console.error("Greška pri učitavanju vrsta", error);
    }
  };

  useEffect(() => {
    if (sredstvo.kategorija) {
      fetchVrste(sredstvo.kategorija);
      if (!editSredstvoData)
        setSredstvo((prev) => ({ ...prev, vrsta: { id: -1, name: "" } }));
    }
  }, [sredstvo.kategorija]);

  useEffect(() => {
    if (editSredstvoData)
      setSredstvo({
        ...editSredstvoData,
        napomena: editSredstvoData.napomena || "",
        uputstvo: editSredstvoData.uputstvo || "",
        foto: null,
        foto_path: editSredstvoData.foto_path || ""
      });
  }, [editSredstvoData]);

  const handleChange = (field, value) =>
    setSredstvo((prev) => ({ ...prev, [field]: value }));
  const handleNazad = () => setCurrentState("");

  const handleDodaj = async () => {
    if (!loggedUser || !apiKey) {
      alert("Greška: Niste ulogovani.");
      return;
    }

    const formData = new FormData();
    formData.append("user_id", loggedUser.id);
    formData.append("api_key", apiKey);
    formData.append("company_id", selectedMainEntity.company_id);
    formData.append("kategorija", sredstvo.kategorija);
    formData.append("vrsta_id", sredstvo.vrsta.id);
    formData.append("tip", sredstvo.tip);
    formData.append("oznaka", sredstvo.oznaka);
    formData.append("poslovna_jedinica_id", sredstvo.poslovnaJedinica.id);
    formData.append("lokacija", sredstvo.lokacija);
    formData.append("status_sredstva", "AKTIVNA");
    formData.append("napomena", sredstvo.napomena || "");
    formData.append("uputstvo", sredstvo.uputstvo || "");
    if (sredstvo.strucniNalazBroj) {
      formData.append("strucni_nalaz_broj", sredstvo.strucniNalazBroj);
      formData.append("strucni_nalaz_istice", sredstvo.strucniNalazIstice);
      if (sredstvo.strucniNalazFile)
        formData.append("strucni_nalaz_file", sredstvo.strucniNalazFile);
    }
    if (editSredstvoData) formData.append("masina_id", editSredstvoData.id);
    if (sredstvo.foto) formData.append("foto", sredstvo.foto);

    try {
      const { data } = await axios.post(
        `${baseUrl}/machines/upsert_machine.php`,
        formData
      );
      if (data.status === 200) {
        alert("Mašina je uspešno sačuvana!");
        if (editSredstvoData) {
          setMasineUredjaji((prev) =>
            prev.map((masina) =>
              masina.masina_id == editSredstvoData.id
                ? {
                    ...mapToBackendData(sredstvo),
                    strucni_nalaz_path: data.file_path
                  }
                : masina
            )
          );
          setSredstvo((prev) => ({
            ...prev,
            strucni_nalaz_path: data.file_path,
            strucniNalazFile: null
          }));
        } else {
          setMasineUredjaji((prev) => [
            ...prev,
            {
              ...mapToBackendData(sredstvo),
              status_sredstva: "AKTIVNA",
              masina_id: data.masina_id,
              strucni_nalaz_path: data.file_path
            }
          ]);
          setSredstvo((prev) => ({
            ...prev,
            strucni_nalaz_path: data.file_path,
            strucniNalazFile: null
          }));
          setCurrentState("");
          window.dispatchEvent(new Event("machineAdded"));
        }
      } else {
        alert(data.message || "Greška pri snimanju mašine.");
      }
    } catch (error) {
      console.error("Greška pri slanju mašine", error);
      alert("Došlo je do greške na serveru.");
    }
  };

  const handleUcitajDokument = () => {
    fileInputRef.current.value = "";
    fileInputRef.current.click();
  };
  const handleFileChange = (e) => {
    const file = e.target.files[0];
    setSredstvo((prev) => ({ ...prev, strucniNalazFile: file }));
  };
  const handleDeleteFile = () =>
    setSredstvo((prev) => ({ ...prev, strucniNalazFile: null }));

  const isEnabledDodaj =
    sredstvo.kategorija &&
    sredstvo.vrsta &&
    sredstvo.tip &&
    sredstvo.oznaka &&
    sredstvo.poslovnaJedinica.name &&
    sredstvo.lokacija &&
    ((sredstvo.strucniNalazBroj &&
      sredstvo.strucniNalazIstice &&
      (sredstvo.strucniNalazFile || sredstvo.strucni_nalaz_path)) ||
      (!sredstvo.strucniNalazBroj &&
        !sredstvo.strucniNalazIstice &&
        !sredstvo.strucniNalazFile));

  return (
    <div
      style={{
        padding: "10px",
        display: "flex",
        flexDirection: "column",
        gap: "10px"
      }}
    >
      {/* Kategorija */}
      <div
        style={{
          display: "flex",
          gap: "5px",
          opacity: editSredstvoData ? 0.5 : 1
        }}
      >
        {kategorijeAll.map((kategorija) => (
          <div
            onClick={() => handleChange("kategorija", kategorija)}
            key={kategorija}
            style={{ width: "33%" }}
          >
            <Button
              isDisabled={!!editSredstvoData}
              activation={true}
              active={sredstvo.kategorija === kategorija}
              style={{ padding: "5px" }}
            >
              {dictionary[kategorija]}
            </Button>
          </div>
        ))}
      </div>

      {/* Foto */}
      <div>
        <input
          type="file"
          accept="image/jpeg,image/png,image/webp"
          ref={fotoInputRef}
          style={{ display: "none" }}
          onChange={(e) => {
            const file = e.target.files[0];
            if (file) handleChange("foto", file);
          }}
        />
        <div
          style={{
            display: "flex",
            gap: "10px",
            alignItems: "center",
            width: "100%"
          }}
        >
          <div
            onClick={() => {
              fotoInputRef.current.value = "";
              fotoInputRef.current.click();
            }}
            style={{ opacity: !sredstvo.kategorija ? 0.5 : 1 }}
          >
            <Button
              isDisabled={!sredstvo.kategorija}
              activation={true}
              style={{ padding: "5px" }}
            >
              ФОТОГРАФИЈА
            </Button>
          </div>
          {sredstvo.foto && (
            <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
              <span style={{ fontSize: "13px" }}>{sredstvo.foto.name}</span>
              <img
                src={deleteImg}
                onClick={() => handleChange("foto", null)}
                style={{ width: "20px", cursor: "pointer" }}
              />
            </div>
          )}
          {!sredstvo.foto && sredstvo.foto_path && (
            <span style={{ fontSize: "13px", color: "#555" }}>
              Fotografija već postoji
            </span>
          )}
        </div>
      </div>

      <CustomSelectWithLabel
        label={dictionary["vrsta"]}
        allValues={vrsteAll}
        selectedValue={sredstvo.vrsta}
        onSelectChange={(v) => handleChange("vrsta", v)}
        disabled={!sredstvo.kategorija}
      />
      <CustomInput
        value={sredstvo.tip}
        onChange={(v) => handleChange("tip", v)}
        label={dictionary["tip"]}
        disabled={!sredstvo.kategorija}
      />
      <CustomInput
        value={sredstvo.oznaka}
        onChange={(v) => handleChange("oznaka", v)}
        label={dictionary["oznaka"]}
        disabled={!sredstvo.kategorija}
      />

      {/* Stručni nalaz */}
      <div>
        <div
          style={{ fontWeight: "bold", fontSize: "16px", marginBottom: "5px" }}
        >
          {dictionary["strucniNalaz"]}
        </div>
        <div style={{ display: "flex", gap: "5px" }}>
          <input
            value={sredstvo.strucniNalazBroj}
            onChange={(e) => handleChange("strucniNalazBroj", e.target.value)}
            style={{ ...styles.input, width: "40%" }}
            disabled={!sredstvo.kategorija}
          />
          <input
            type="date"
            value={sredstvo.strucniNalazIstice}
            onChange={(e) => handleChange("strucniNalazIstice", e.target.value)}
            style={{ ...styles.input, width: "60%" }}
            disabled={!sredstvo.kategorija}
            onKeyDown={(e) => e.preventDefault()}
          />
        </div>
      </div>

      <input
        type="file"
        accept="image/*, .pdf, .docx"
        ref={fileInputRef}
        style={{ display: "none" }}
        onChange={handleFileChange}
      />
      <div
        onClick={handleUcitajDokument}
        style={{ opacity: !sredstvo.kategorija ? 0.5 : 1 }}
      >
        <Button
          isDisabled={!sredstvo.kategorija}
          activation={true}
          style={{ padding: "5px" }}
        >
          UCITAJ DOKUMENT
        </Button>
      </div>
      {sredstvo.strucniNalazFile && (
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <div>Ucitani dokument: {sredstvo.strucniNalazFile.name}</div>
          <div onClick={handleDeleteFile}>
            <img
              src={deleteImg}
              style={{ width: "25px", height: "25px", cursor: "pointer" }}
            />
          </div>
        </div>
      )}
      {sredstvo.strucni_nalaz_path && (
        <a
          href={baseUrl.slice(0, -4) + sredstvo.strucni_nalaz_path}
          target="_blank"
        >
          Pregledaj dokument
        </a>
      )}

      <CustomSelectWithLabel
        label={dictionary["poslovnaJedinica"]}
        allValues={poslovneJediniceAll}
        selectedValue={sredstvo.poslovnaJedinica}
        onSelectChange={(v) => handleChange("poslovnaJedinica", v)}
        disabled={!sredstvo.kategorija}
      />
      <CustomAutocomplete
        label={dictionary["lokacija"]}
        allValues={lokacijeAll}
        selectedValue={sredstvo.lokacija}
        onSelectChange={(v) => handleChange("lokacija", v)}
        disabled={!sredstvo.kategorija}
        isUp={false}
      />

      {/* Napomena */}
      <div>
        <div
          style={{ fontWeight: "bold", fontSize: "16px", marginBottom: "5px" }}
        >
          {dictionary["napomena"] || "Напомена"}
        </div>
        <textarea
          value={sredstvo.napomena}
          onChange={(e) => handleChange("napomena", e.target.value)}
          disabled={!sredstvo.kategorija}
          style={{
            width: "100%",
            fontSize: "16px",
            padding: "10px",
            minHeight: "80px",
            resize: "vertical"
          }}
        />
      </div>

      {/* Uputstvo */}
      <div>
        <div
          style={{ fontWeight: "bold", fontSize: "16px", marginBottom: "5px" }}
        >
          {dictionary["uputstvo"] || "Упутство за употребу"}
        </div>
        <textarea
          value={sredstvo.uputstvo}
          onChange={(e) => handleChange("uputstvo", e.target.value)}
          disabled={!sredstvo.kategorija}
          style={{
            width: "100%",
            fontSize: "16px",
            padding: "10px",
            minHeight: "80px",
            resize: "vertical"
          }}
        />
      </div>

      <div style={{ display: "flex", gap: "10px", marginTop: "10px" }}>
        <div
          onClick={handleDodaj}
          style={{ flex: 1, opacity: isEnabledDodaj ? 1 : 0.5 }}
        >
          <Button
            isDisabled={!isEnabledDodaj}
            activation={true}
            style={{ padding: "10px", width: "100%" }}
          >
            {editSredstvoData ? dictionary["azuriraj"] : dictionary["dodaj"]}
          </Button>
        </div>
        {!editSredstvoData && (
          <div onClick={handleNazad} style={{ flex: 1 }}>
            <Button
              activation={true}
              style={{ padding: "10px", width: "100%" }}
            >
              {dictionary["nazad"]}
            </Button>
          </div>
        )}
      </div>
    </div>
  );
}

export default DodavanjeSredstva;
